import { computed } from 'vue';

import { useLicenseStore } from '@/stores/licenseStore';

import NetworkMetricsPage from '@/components/stats/NetworkMetricsPage.vue';
import BreaksGanttPage from '@/components/stats/BreaksGanttPage.vue';
import PaasPage from '@/components/stats/PaasPage.vue';
import NetworkRtkStatsPage from '@/components/stats/NetworkRtkStatsPage.vue';
import DelaysChartPage from '@/components/stats/DelaysChartPage.vue';
import GnssVisibilityChartGroupBaseStationStatsPage from '@/components/stats/GnssVisibilityChartGroupBaseStationStatsPage.vue';
import ConvergenceChartPage from '@/components/stats/ConvergenceChartPage.vue';
import SpoofingPage from '@/components/stats/SpoofingPage.vue';
import BrdcmStatsPage from '@/components/stats/BrdcmStatsPage.vue';

import ResidualsStatsPage from '@/components/stats/ResidualsStatsPage.vue';
import AtmosphereConditionStatsPage from '@/components/stats/AtmosphereConditionStatsPage.vue';
import GnssVisibilityChartPage from '@/components/stats/GnssVisibilityChartPage.vue';
import ByGnssStatsPage from '@/components/stats/ByGnssStatsPage.vue';


const TABS_BY_SUBNETWORKS = [
	{ value: 'by-gnss', component: ByGnssStatsPage },
	{ value: 'residuals', component: ResidualsStatsPage },
	{ value: 'atmosphere-condition', component: AtmosphereConditionStatsPage },
	{ value: 'detailed', component: GnssVisibilityChartPage },
];

const STATS_BASE_ROUTES = [
	{ value: 'network-rtk', component: NetworkRtkStatsPage },
	{ value: 'by-subnetworks', component: null, tabs: TABS_BY_SUBNETWORKS },
	{ value: 'breaks-gantt', component: BreaksGanttPage },
	{ value: 'coordinates-correction', component: PaasPage },
	{ value: 'delays-chart', component: DelaysChartPage },
	{ value: 'gnss-visibility', component: GnssVisibilityChartGroupBaseStationStatsPage },
	{ value: 'convergence', component: ConvergenceChartPage },
	{ value: 'spoofing', component: SpoofingPage },
	{ value: 'brdcm', component: BrdcmStatsPage },
	{ value: 'network-metrics', component: NetworkMetricsPage },
];

export const useStatsRoutes = () => {
	const licenseStore = useLicenseStore();
	return computed(() => STATS_BASE_ROUTES.filter(route => (
		(route.value !== 'brdcm' || licenseStore.allowBrdcm)
		&& (route.value !== 'spoofing' || licenseStore.featureFlagJamming)
	)).map(route => route.value === 'by-subnetworks' ? {
		...route,
		tabs: route.tabs.filter(tab => (
			tab.value !== 'atmosphere-condition'
			|| licenseStore.allowVrs
			|| licenseStore.allowPppRtk
			|| licenseStore.allowPppGp
		)),
	} : route));
};
